<script setup lang="ts">
const props = defineProps({
  widget: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <div
    id="home-block-2"
    class="block-container"
  >
    <div
      block-name="Categorias LifeStyle"
      section="home"
      class="promo-categories-ls promo-categories__container"
      style="background-color: #d64000; background-repeat: repeat;background-size:unset;
         background-image: url('/content/images/tiles/img_3.png');"
    >
      <div class="container">
        <div class="row">
          <div class="col s12 m12 l12">
            <div class="promo-categories__header">
              <div class="promo-categories__countdown" />
            </div>
            <div class="promo-categories">
              <NuxtLink
                to="/cascos-cafe-racer" 
                class="mtc-link"
              >
                <svg
                  height="55"
                  width="55"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 171 171"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke-linecap="round"
                    stroke-width="2.7"
                    transform="translate(2 2)"
                  >
                    <path d="m79.712 64.11c0-3.825 3.094-6.926 6.91-6.926s6.91 3.1 6.91 6.925-3.094 6.926-6.91 6.926-6.91-3.101-6.91-6.926z" />
                    <path d="m159.335 136.613c.209 5.085.104 10.51-.965 13.37-2.369 6.332-12.24 17.017-12.24 17.017-67.913-37.2-139.774-55.799-139.774-55.799s-.79-28.89-6.318-36.012c-.789-17.411 11.055-40.76 11.055-40.76v-7.913s9.477-26.516 71.797-26.516c44.54 0 64.507 31.333 72.275 49.21" />
                    <path d="m159.423 61.34s-9.477.211-21.145-1.759c-12.303-2.075-32.124-6.63-41.131-9.55-9.008-2.92-22.988-3.65-27.029 11.341-4.041 14.992 3.526 27.49 18.153 35.866 14.625 8.378 27.15 16.536 70.099 27.516 7.5-35.163 1.053-63.414 1.053-63.414z" />
                  </g>
                </svg>
                <h2>Cascos</h2>
              </NuxtLink>
              <NuxtLink
                to="/chaquetas-cafe-racer" 
                class="mtc-link"
              >
                <svg
                  height="55"
                  width="55"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 200 195"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke-linecap="round"
                    stroke-width="2.7"
                    transform="translate(2 2)"
                  >
                    <path d="m92.875 175.305c31.533 0 46.697-7.31 46.697-7.31s.364-15.73.705-28.574c.342-12.842 4.725-54.648 4.725-54.648s3.138 11.143 6.59 21.343c3.453 10.2 5.493 19.3 2.354 39.232-3.139 19.929-12.55 37.868-12.55 37.868 9.523 16.007 22.982 12.9 22.982 12.9s7.567-21.7 12.276-33.888 9.144-41.832 8.136-50.783c-1.01-8.95-10.131-41.734-21.492-70.488-11.358-28.75-35.734-27.49-41.923-29.104s-10.324-10.637-10.324-10.637-.521-1.45-2.831-1.183c-2.309.264-8.992 1.765-15.762 1.765h.019c-6.769 0-13.454-1.501-15.762-1.765-2.31-.267-2.83 1.183-2.83 1.183s-4.135 9.024-10.322 10.637c-6.19 1.613-30.567.354-41.926 29.104-11.359 28.754-20.483 61.539-21.493 70.488-1.008 8.95 3.43 38.595 8.137 50.783 4.71 12.188 12.278 33.888 12.278 33.888s13.457 3.107 22.98-12.9c0 0-9.412-17.94-12.55-37.868-3.137-19.931-1.097-29.031 2.353-39.232 3.452-10.2 6.591-21.343 6.591-21.343s4.383 41.806 4.724 54.648c.342 12.844.706 28.574.706 28.574s15.979 7.31 47.512 7.31z" />
                    <path
                      d="m93.092 145.952v-118.61"
                      stroke-linecap="round"
                    />
                    <path d="m73.984 3.57s2.905 15.615 17.533 15.96c14.627.346 20.595-15.934 20.595-15.934l3.809 4.86s-5.175 18.882-22.828 18.887c-20.507.008-22.829-18.887-22.829-18.887l3.72-4.887z" />
                  </g>
                </svg>
                <h2>Chaquetas</h2>
              </NuxtLink>
              <NuxtLink
                to="/guantes-cafe-racer" 
                class="mtc-link"
              >
                <svg
                  height="55"
                  width="55"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 200 195"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke-linecap="round"
                    stroke-width="2.835"
                    transform="translate(2.234 2.024)"
                  >
                    <path d="m159.31 157.468s4.328 2.355 9.273 1.054c4.947-1.302 6.8-5.877 5.811-10.328-.988-4.45-5.687-20.154-5.935-26.71-.246-6.552-4.45-25.594-8.16-32.767" />
                    <path d="m174.54 151.907s3.687 1.728 3.317-6.309c-.372-8.037 1.977-30.295 1.113-36.973-.867-6.676-5.811-22.752-5.811-22.752" />
                    <path d="m178.383 130.26s5.779-6.796 5.16-18.171c-.616-11.377.264-19.539-4.38-30.668-4.645-11.128-6.252-15.209-16.515-26.46-10.262-11.253-25.1-36.973-30.044-45.01-4.947-8.04-3.71-9.274-10.758-9.894-7.048-.617-27.325 3.712-37.71 17.312 0 0 .988 6.678 3.585 11.376 0 0 5.193 10.634 5.069 11.625-.122.988-6.676 27.699-7.912 44.638-1.237 16.94 1.236 44.886 8.53 45.008 7.296.126 7.79-8.531 9.521-17.805s2.968-19.29 5.193-20.403 11.375 7.05 16.94 15.704c5.563 8.655 15.702 34.005 19.658 40.683 3.956 6.677 9.15 12.86 14.59 9.274s3.216-13.973 1.855-17.435c-1.36-3.462-17.31-49.215-17.31-49.215m-64.046-66.895-1.731.122c-1.73.126-17.928 19.538-20.277 21.641-2.35 2.102-13.107 8.284-19.907 10.51s-20.525 11.252-29.304 23.742c-8.779 12.488-9.398 13.6-8.037 19.783 1.36 6.183 9.767 1.36 12.117-.495 2.349-1.855 19.412-12.982 20.154-13.354.74-.37-19.66 38.458-22.75 47.36-3.092 8.903-5.935 15.333-1.609 21.887 4.329 6.552 11.128 3.105 14.714-4.013m63.43-16.335s-4.205 11.939-7.913 15.401c-3.71 3.462-13.354.742-14.344-3.958-.989-4.697 10.386-24.606 10.386-24.606m-10.386 24.606s-1.483 8.286-9.397 8.286c0 0-12.735.74-10.633-9.522 2.103-10.263 10.51-25.348 10.51-25.348" />
                    <path d="m44.088 148.317s-.384 6.237-5.453 7.324c-5.07 1.085-16.692 1.828-15.208-7.324 1.483-9.15 16.94-35.858 16.94-35.858m112.232-56.221s-23.72 6.404-27.635 11.03c-3.914 4.626-.236 16.251 6.168 17.794 6.405 1.54 9.014-.95 12.098-3.085 3.083-2.134 5.099 1.187 9.37.593 4.27-.593 3.696-4.507 6.71-4.983 3.014-.474 7.278 1.264 10.25.12m-89.535-30.327s-11.059-4.634-17.656-6.683m-8.149 44.843s15.144-7.643 14.9-19.473c-.243-11.83-3.902-16.708-3.902-16.708m70.243-34.683s-12.703 2.25-20.83 5.963" />
                  </g>
                </svg>
                <h2>Guantes</h2>
              </NuxtLink>
              <NuxtLink
                to="/botas-cafe-racer" 
                class="mtc-link"
              >
                <svg
                  height="55"
                  width="55"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 200 195"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke-linecap="round"
                    stroke-width="2.835"
                    transform="translate(2.264 1.504)"
                  >
                    <path d="m7.016 18.206s-3.906-5.723-2.879-11.086c1.029-5.363 6.99-7.418 21.38-7.007 14.392.412 50.37 6.733 51.191 9.021.823 2.286-6.166 27.37-7.606 35.388-1.438 8.019-6.168 40.298-4.934 56.335 1.235 16.037 9.662 27.14 15.624 32.074 5.963 4.936 17.682 13.983 28.372 15.421s16.241 10.691 11.923 18.504c-4.317 7.815-21.38 7.143-34.126 8.507-12.746 1.361-23.848 2.39-34.538-1.104-10.69-3.498-14.598-4.319-14.598-4.319s-7.4 3.29-17.064 1.85c-9.661-1.438-17.268-4.728-18.09-9.047-.825-4.317-1.671-7.194-1.671-7.194s.026-14.966 1.67-20.746c1.646-5.778 6.168-14.208 6.374-16.673.206-2.469 1.438-28.168 1.233-38.038-.206-9.868-2.261-61.886-2.261-61.886z" />
                    <path
                      d="m126.97 173.121c8.018.499 15.549-.152 26.245-.887 15.458-1.059 19.04-3.309 23.132-7.25 4.092-3.937 4.218-15.503-4.243-17.126-3.288-.63-19.703-3.18-31.524-9.396-11.82-6.214-22.126-20.158-26.218-35.92-4.092-15.764-.757-28.647 1.667-35.62 2.425-6.97 10.913-32.584 11.254-36.373.342-3.79-.645-11.067-.341-12.58.302-1.516 1.06-7.58-1.516-8.944-2.146-1.134-36.755-7.93-49.933-8.964 0 0-3.566-.511-4.536 1.425"
                      stroke-linejoin="round"
                    />
                    <path d="m7.851 138.964s12.242 19.108 14.934 19.78c2.69.674 27.082 10.091 27.082 10.091s3.631-15.47 24.706-14.349c21.075 1.12 30.042 5.155 31.164 9.192" />
                    <path
                      d="m178.087 162.355s-24.531 5.932-51.117 4.922"
                      stroke-linejoin="round"
                    />
                    <path d="m16.748 102.36s4.55-.157 6.276 2.982c1.727 3.137 5.177 8.471 3.922 11.454-1.255 2.982-6.432 11.612-11.14 11.769-4.707.156-5.333-3.923-5.333-3.923m116.467-106.674s-7.993 1.312-17.243 0c-9.254-1.31-14.573-1.542-16.655 4.934-2.082 6.478-7.97 27.15-3.754 35.318 4.216 8.17 12.312 9.56 13.931 9.79m-27.727-50.786s-20.152 2.439-30.329-1.263c-10.177-3.701-28.219-8.794-30.068-2.199-1.85 6.594 7.402 26.026 5.55 38.286-1.85 12.26.925 26.602 5.551 25.677s6.246-10.642 15.96-11.105" />
                  </g>
                </svg>
                <h2>Botas</h2>
              </NuxtLink>
              <NuxtLink
                to="/pantalones-cafe-racer" 
                class="mtc-link"
              >
                <svg
                  height="55"
                  width="55"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 205"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    stroke-width="2.835"
                    transform="translate(1.59 2.208)"
                  >
                    <path d="m26.107 4.8s.503 15.582-14.42 23.94m-10.68 88.348s12.189-9.358 25.67 0m-13.317 27.085h-.297c-2.84 0-5.163-2.413-5.163-5.359v-10.946c0-2.944 2.323-5.36 5.163-5.36h.297c2.84 0 5.165 2.416 5.165 5.36v10.946c0 2.946-2.325 5.36-5.165 5.36z" />
                    <path d="m42.432 0h-31.263c-2.226 0-4.029 1.869-4.029 4.182v16.698s-11.002 129.206-5.692 170.566c0 0-.755 2.365 7.589 2.755 8.35.397 12.143-1.179 12.143-1.179s1.138-5.12 1.138-9.061c0-3.939 7.59-114.238 7.59-114.238s1.518-13.002 12.524-13.002h-.38c11.003 0 12.523 13.002 12.523 13.002s7.586 110.3 7.586 114.238c0 3.94 1.14 9.061 1.14 9.061s3.795 1.576 12.142 1.18c8.348-.391 7.588-2.756 7.588-2.756 5.315-41.36-5.69-170.566-5.69-170.566v-16.698c-.001-2.313-1.801-4.182-4.027-4.182h-31.262v29.542m16.468-24.889s-.504 15.583 14.421 23.943m10.535 88.492s-12.19-9.358-25.67 0" />
                    <path d="m71.122 144.173h.297c2.838 0 5.162-2.413 5.162-5.359v-10.946c0-2.944-2.324-5.36-5.162-5.36h-.297c-2.84 0-5.165 2.416-5.165 5.36v10.946c0 2.946 2.325 5.36 5.165 5.36zm-13.706-32.866s11.956-81.368-14.984-81.764h-.38c-26.94.396-14.986 81.764-14.986 81.764" />
                  </g>
                </svg>
                <h2>Pantalones</h2>
              </NuxtLink>
              <NuxtLink
                to="/camisas-cafe-racer"
                class="mtc-link"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <path
                      stroke="#ffffff"
                      stroke-width="1.8"
                      d="M28.085 52.772V20.955"
                    />
                    <path
                      stroke="#ffffff"
                      stroke-width="1.5"
                      d="M22.3 2.025s1.053 4.928 5.324 5.03c4.271.101 6.014-4.678 6.014-4.678l1.52 1.951s-1.918 5.018-7.073 5.02c-5.987.002-7.327-5.29-7.327-5.29L22.3 2.024Z"
                    />
                    <path
                      stroke="#ffffff"
                      stroke-width="1.5"
                      d="M33.656 2.294c-.213-.363-.328-.616-.328-.616s-.152-.425-.827-.347c-.673.078-2.624.517-4.598.519-1.976-.002-3.927-.441-4.6-.52-.675-.077-.827.348-.827.348s-.106.233-.3.568m23.485 31.17c.862 2.73 1.036 5.182.193 10.569-.917 5.85-3.666 11.117-3.666 11.117C44.97 59.8 48.9 58.888 48.9 58.888s2.21-6.37 3.585-9.946c1.375-3.579 2.67-12.28 2.376-14.908-.248-2.217-2.06-9.086-4.651-16.352m-36.474 21.31c.143 1.786.18 2.266.207 3.254.1 3.77.206 8.388.206 8.388s4.666 2.146 13.873 2.146c9.207 0 13.635-2.146 13.635-2.146s.106-4.618.206-8.388c.022-.792.05-1.716.153-3.065M5.51 17.903C2.898 25.208 1.195 31.806.944 34.035.65 36.661 1.946 45.365 3.32 48.941c1.375 3.577 3.586 9.948 3.586 9.948s3.928.91 6.71-3.787c0 0-2.748-5.266-3.664-11.116-.917-5.85-.88-7.97.128-10.965"
                    />
                    <path
                      fill="#ffffff"
                      d="M33.13 49.085a.83.83 0 0 0-.328.816.855.855 0 0 0 .336.549c.18.134.4.188.618.152l.033-.005c.443-.07.753-.517.677-.966a.855.855 0 0 0-.336-.55.814.814 0 0 0-.619-.152.871.871 0 0 0-.381.156"
                    />
                    <path
                      stroke="#ffffff"
                      stroke-width="1.5"
                      d="m35.985 49.439 2.533-.405M28.085 14.819V9.433M18.576 4.845S16.15 2.44 11.762 4.57C7.375 6.7 5.71 11.111 5.255 12.581c-.453 1.471 1.01 2.84 2.623 2.941 1.615.102 1.16-1.419 4.288-4.21 3.127-2.788 4.752-2.133 6.41-6.467ZM25.65 17.95s-3.766-.196-5.09-3.077c-1.32-2.881-1.763-4.21-3.23-4.21-.853.016-4.525 2.707-5.144 3.988-.75 1.55.587 10.931.44 15.29-.146 4.358 2.498 7.755 5.584 8.494 3.087.74 7.469-6.648 7.469-6.648l-.029-13.837ZM37.741 4.845s2.427-2.405 6.815-.276c4.387 2.131 6.053 6.542 6.506 8.012.454 1.471-1.009 2.84-2.622 2.941-1.615.102-1.16-1.419-4.288-4.21-3.127-2.788-4.752-2.133-6.41-6.467ZM30.726 17.95s3.766-.196 5.09-3.077c1.32-2.881 1.763-4.21 3.23-4.21.853.016 4.525 2.707 5.144 3.988.75 1.55-.587 10.931-.44 15.29.147 4.358-2.498 7.755-5.584 8.494-3.086.74-7.469-6.648-7.469-6.648l.029-13.837Z"
                    />
                  </g>
                </svg>
                <h2>Protecciones</h2>
              </NuxtLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /categorias -->
</template>

<style scoped>
.container {
  margin: 0 auto;
  max-width: 1280px;
  width: 95%;
}

.promo-categories a.mtc-link {
  /* background-color: darksalmon; */
  background-color: #a67767;
  background-image: none;
  box-shadow: 0 0 0 #000;
  border: 1px solid #fff;
}

.promo-categories .mtc-link svg {
  align-self: center;
  display: block;
  height: 58px;
  justify-self: center;
  margin: 0 auto 15px;
  width: auto;
  /* stroke: #262626; */
  stroke: #fff;
}

.promo-categories .mtc-link h2 {
  color: #fff;
}

.block-container {
  background-color: #f5f5f5;
}

.promo-categories__container {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 45px 0 40px;
}
.promo-categories__header {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 30px;
  max-height: 79px;
}

.promo-categories {
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-bottom: 40px;
}

.promo-categories .mtc-link {
  align-items: center;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  justify-content: flex-end;
  padding: 30px 5px;
  transition: all .65s ease-out;
}

.promo-categories .mtc-link img {
  align-self: center;
  display: block;
  height: 58px;
  justify-self: center;
  margin: 0 auto 15px;
  width: auto;
}

.promo-categories .mtc-link h2 {
  display: block;
  font-size: 12px;
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
  margin: 0px;
}

@media only screen and (max-width: 600px) {
  .promo-categories .mtc-link {
    flex: 0 0 45%;
  }
}

@media only screen and (min-width: 601px) and (max-width: 992px) {
  .promo-categories .mtc-link {
    flex: 0 0 32%;
    justify-content: center;
    padding: 20px 0;
  }
}
@media only screen and (max-width: 600px) {
  .promo-categories {
    flex-wrap: wrap;
    margin-bottom: 20px;
  }
}
</style>
